/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type userChangePasswordQueryVariables = {
    id: string;
};
export type userChangePasswordQueryResponse = {
    readonly user: {
        readonly " $fragmentRefs": FragmentRefs<"ChangePasswordUser_data">;
    };
};
export type userChangePasswordQuery = {
    readonly response: userChangePasswordQueryResponse;
    readonly variables: userChangePasswordQueryVariables;
};



/*
query userChangePasswordQuery(
  $id: ID!
) {
  user(id: $id) {
    ...ChangePasswordUser_data
    id
  }
}

fragment ChangePasswordUser_data on User {
  id
  email
  firstName
  lastName
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userChangePasswordQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChangePasswordUser_data"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userChangePasswordQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "434774676a028b8ae9e3dc5c5986db3d",
    "id": null,
    "metadata": {},
    "name": "userChangePasswordQuery",
    "operationKind": "query",
    "text": "query userChangePasswordQuery(\n  $id: ID!\n) {\n  user(id: $id) {\n    ...ChangePasswordUser_data\n    id\n  }\n}\n\nfragment ChangePasswordUser_data on User {\n  id\n  email\n  firstName\n  lastName\n}\n"
  }
};
})();
(node as any).hash = 'b5c42d42319b9b07b004886caa21c6ee';
export default node;
